/**
 * Shared trending score calculation.
 *
 * Used by both the trending-tokens edge function (Deno) and the client-side
 * MarketDataProvider for real-time cache patches. Keep this function pure
 * and free of imports so it can be copy-pasted into the edge function if needed.
 *
 * Algorithm (volume-dominant):
 * - Volume Score (60%): sqrt-scaled 24h volume in SOL
 * - Trade Count Score (20%): Number of trades
 * - Trader Score (10%): Unique traders
 * - Recency Score (10%): Freshness bonus
 */

export function calculateTrendingScore(
  volume24h: number,
  tradeCount24h: number,
  holderCount: number,
  createdAt: Date
): number {
  // 1. Volume Score (60% weight) - sqrt scaling preserves meaningful differences
  const volumeScore = volume24h > 0
    ? Math.min(100, Math.sqrt(volume24h) * 10)
    : 0;

  // 2. Trade Count Score (20% weight)
  const tradeScore = Math.min(100, tradeCount24h * 2.5);

  // 3. Unique Trader Score (10% weight)
  const traderScore = Math.min(100, holderCount * 5);

  // 4. Recency Score (10% weight)
  const hoursSinceCreation = (Date.now() - createdAt.getTime()) / 3_600_000;
  const recencyScore = Math.max(0, 100 - hoursSinceCreation * 4);

  return (
    volumeScore * 0.60 +
    tradeScore * 0.20 +
    traderScore * 0.10 +
    recencyScore * 0.10
  );
}
